<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0"
        y="0"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <path
                d="M20 0h-9a1 1 0 1 0 0 2h9c.179 0 .352.024.518.068L.293 22.293a.999.999 0 1 0 1.414 1.414L21.932 3.482c.044.165.068.339.068.518v9a1 1 0 1 0 2 0V4c0-2.206-1.794-4-4-4Z"
                fill="#000000"
                opacity="1"
                data-original="#000000"></path>
        </g>
    </svg>
</template>
